import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'

import * as actions from './actions'
import * as apiActions from '../api/actions'
import { cloneMap } from '../root/functions'
import { MapRoute } from 'mytours-read-api-typescript'

export interface StoreState {
	readonly mapRoutes: Map<number, MapRoutesState>
}

interface MapRoutesState {
	mapRoute?: any
	attributes: {
		id: number
		version: number
		linkedId: number
		error?: Error
		linkedType?: MapRoute.LinkedTypeEnum
	}
}

const INITIAL_STATE: StoreState = {
	mapRoutes: new Map(),
}

export const reducer = reducerWithInitialState(INITIAL_STATE)
	.case(
		actions.loadedMapRouteFromDisk,
		(state, payload): StoreState => {
			const updatedRoutes = cloneMap(state.mapRoutes)
			updatedRoutes.set(payload.mapRouteId, {
				...payload.mapRoute,
				attributes: {
					id: payload.mapRouteId,
					version: payload.mapRouteVersion,
					linkedId: payload.linkedId,
					linkedType: payload.linkedType,
				},
			})
			return {
				...state,
				mapRoutes: updatedRoutes,
			}
		},
	)
	.case(
		apiActions.fetchMapRoute.done,
		(state, payload): StoreState => {
			const updatedRoutes = cloneMap(state.mapRoutes)
			updatedRoutes.set(payload.params.mapRouteId, {
				...payload.result,
				attributes: {
					id: payload.params.mapRouteId,
					version: payload.params.mapRouteVersion,
					linkedId: payload.params.linkedId,
					linkedType: payload.params.linkedType,
				},
			})
			return {
				...state,
				mapRoutes: updatedRoutes,
			}
		},
	)
